export default "__VITE_ASSET__Dx$oHm8l__"